// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
export class ColumnParams {
    constructor(headerKey, // 1
    width, // 2
    alignment, // 3
    aggregateVisibility, // 4
    visible, // 5
    allowGrouping, // 6
    hidden, // 7
    beginGroupFlag, // 8
    emptyValue /* 9 */) {
        this.TextCompareColumn = false; // Для ВЕБа - на обновление данных должно сравниваться (строковое значение, а не getValue)
        this.Locale = ''; // Установить язык, который будет использоваться
        this.FormatPrice = false; // Использовать форматирование цены
        this.FormulaKey = '';
        this.MenuIndex = 1000;
        this.AutoGenerated = false;
        this.HeaderKey = headerKey;
        this.aggregateVisibility = aggregateVisibility;
        this.alignment = alignment;
        this.Width = width;
        this.Visible = visible;
        const hiddenValue = hidden !== null && hidden !== void 0 ? hidden : false;
        this.DefaultHidden = hiddenValue;
        this.Hidden = hiddenValue;
        this.AllowGrouping = allowGrouping;
        this.BeginGroup = beginGroupFlag || false;
        this.EmptyValue = emptyValue || 0;
    }
    // Текст колонки (локализированный)
    HeaderText() {
        if (isNullOrUndefined(this.Locale)) {
            return Resources.getResource(this.HeaderKey);
        }
        else {
            return this.HeaderKey;
        }
        //    return Resources.getResourceLang(this.HeaderKey, this.Locale);
    }
}
